import React from 'react';
import { Grid } from '@material-ui/core';
import { withRouter } from '../../../util/router-compatibility';
import { useStyles } from './manage-roles.style';
 
import { DataGrid } from '@orijinworks/frontend-commons';
import AddIcon from '@material-ui/icons/Add';
import AddNewRoleDialog from '../../../components/manage-roles-permissions/add-new-role-dialog';
import ManageRoleAndPermission from '../../../components/manage-roles-permissions/manageRoleAndPermission';
import { useManageRoleHook } from './useManageRoleHook';
 
const ManageRolesV2 = ({ history }) => {
  const classes = useStyles();
  const {
    isNewRoleDialogOpen,
    handleNewRoleDialogOpen,
    handleNewRoleDialogClose,
    columns: dataGridColumns,
    pageSize,
    rolesData,
    loading,
    refreshRoles,
    shouldShowManageProgramsNewUI,
  } = useManageRoleHook(history);
 
  return (
    <>
      {shouldShowManageProgramsNewUI ? (
        <div className={classes.container}>
          <div className={classes.gridItem}>
            <div className={classes.dataGridWrapper}>
              <DataGrid
                columns={dataGridColumns}
                data={rolesData}
                pageSize={pageSize}
                pageSizeOptions={[5, 10, 25, 50]}
                paginationMode="client"
                isLoading={loading}
                isAllSelected={false}
                showSelection={true}
                onRefreshHandler={refreshRoles}
                onSelectionChange={() => {}}
                tdStyles={{
                  locationNames: {
                    wordBreak: 'break-all'
                  },
                }}
                headerStyles={classes.headerStyle}
                containerStyle={classes.containerStyle}
                primaryButtonProps={{
                  text: 'Add Role',
                  variant: 'contained',
                  startIcon: <AddIcon />,
                  onClick: handleNewRoleDialogOpen,
                }}
              />
            </div>
            <div className={classes.addRoleModal}>
              <AddNewRoleDialog open={isNewRoleDialogOpen} handleClose={handleNewRoleDialogClose} />
            </div>
          </div>
        </div>
      ) : (
        <ManageRoleAndPermission />
      )}
    </>
  );
};
 
export default withRouter(ManageRolesV2);
